import TemplateManager_LP from "../../landing_pages/templates/TemplateManager";
import TemplateManager_Form from "../../forms/templates/TemplateManager";
import ThankYouTemplateManager from "./ThankYouTemplateManager";
import { PAGE_TYPE } from "../../page_designer/ComponentList";

export default class TemplateManager {
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  static getLandingPageFunnelTemplate(templateIndex) {
    return [
      {
        title: "Landing Page",
        path: "/home",
        pageType: PAGE_TYPE.PEOPLE_EMAIL_TEMPLATE,
        templateData: TemplateManager_LP.getTemplateData(templateIndex),
      },
      {
        title: "Thank You Page",
        path: "/thank-you",
        pageType: PAGE_TYPE.THANK_YOU_PAGE,
        templateData: ThankYouTemplateManager.getTemplateData(templateIndex),
      },
    ];
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  static getLeadMagnetFunnelTemplate(templateIndex) {
    return [
      {
        title: "Landing Page",
        path: "/home",
        pageType: PAGE_TYPE.PEOPLE_EMAIL_TEMPLATE,
        templateData: TemplateManager_LP.getTemplateData(templateIndex),
      },
      {
        title: "Contact Form",
        path: "/contact-form",
        pageType: PAGE_TYPE.FORM,
        templateData: TemplateManager_Form.getTemplateData(templateIndex),
      },
      {
        title: "Thank You Page",
        path: "/thank-you",
        pageType: PAGE_TYPE.THANK_YOU_PAGE,
        templateData: ThankYouTemplateManager.getTemplateData(templateIndex),
      },
    ];
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  static getContactFunnelTemplate(templateIndex) {
    return [
      {
        title: "Contact Form",
        path: "/contact-form",
        pageType: PAGE_TYPE.FORM,
        templateData: TemplateManager_Form.getTemplateData(templateIndex),
      },
      {
        title: "Thank You Page",
        path: "/thank-you",
        pageType: PAGE_TYPE.THANK_YOU_PAGE,
        templateData: ThankYouTemplateManager.getTemplateData(templateIndex),
      },
    ];
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
}
